import { Sun, Grid3x3, Sprout, BatteryCharging, ClipboardCheck, Wrench, Volume2, Zap } from "lucide-react";

export const SERVICES = [
  {
    id: "cati-ges",
    icon: Sun,
    title: "Çatı GES",
    short: "Çatı Üstü Güneş Enerji Santrali",
    desc: "Konut, ticari ve endüstriyel çatılara özel tasarlanan, alanı verime dönüştüren çatı üstü GES çözümleri.",
    image: "https://images.pexels.com/photos/17965455/pexels-photo-17965455.jpeg",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    id: "arazi-ges",
    icon: Grid3x3,
    title: "Arazi GES",
    short: "Lisanslı & Lisanssız Arazi Santralleri",
    desc: "Büyük ölçekli enerji üretimi için mühendislik odaklı arazi tipi güneş santralleri.",
    image: "https://images.pexels.com/photos/35726122/pexels-photo-35726122.jpeg",
    span: "lg:col-span-5",
  },
  {
    id: "tarimsal-sulama",
    icon: Sprout,
    title: "Tarımsal Sulama GES",
    short: "Güneşle Çalışan Sulama Sistemleri",
    desc: "Tarımsal sulama pompalarını güneş enerjisiyle çalıştırarak enerji maliyetini sıfıra indirin.",
    image: "https://images.unsplash.com/photo-1776918570518-a4304917c52c",
    span: "lg:col-span-5",
  },
  {
    id: "oz-tuketim",
    icon: BatteryCharging,
    title: "Öz Tüketim",
    short: "Kendi Enerjini Üret & Tüket",
    desc: "Ürettiğiniz enerjiyi anında tüketerek şebeke bağımlılığını ve faturaları minimize edin.",
    image: null,
    span: "lg:col-span-4",
  },
  {
    id: "danismanlik",
    icon: ClipboardCheck,
    title: "Danışmanlık",
    short: "Fizibilite & Proje Danışmanlığı",
    desc: "Yatırımınızın her aşamasında fizibilite, ruhsat ve teşvik süreçlerinde uzman danışmanlık.",
    image: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxlbmdpbmVlcnMlMjBpbnN0YWxsaW5nJTIwc29sYXIlMjBwYW5lbHxlbnwwfHx8fDE3ODI2Mjc5MjV8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
  {
    id: "bakim",
    icon: Wrench,
    title: "Bakım & O&M",
    short: "İşletme ve Bakım Hizmetleri",
    desc: "Santralinizin ömrü boyunca maksimum verimde çalışması için periyodik bakım ve izleme.",
    image: null,
    span: "lg:col-span-4",
  },
  {
    id: "jenerator",
    icon: Volume2,
    title: "Sessiz Jeneratör",
    short: "Sessiz Jeneratör Sistemleri",
    desc: "Kesintisiz enerji için düşük gürültülü, yüksek verimli sessiz jeneratör kurulumları.",
    image: null,
    span: "lg:col-span-6",
  },
  {
    id: "sarj-istasyonu",
    icon: Zap,
    title: "EV Şarj İstasyonu",
    short: "Elektrikli Araç Şarj Çözümleri",
    desc: "Elektrikli araç şarj istasyonu kurulum, tedarik ve teknik destek hizmetleri.",
    image: "https://images.pexels.com/photos/33508509/pexels-photo-33508509.jpeg",
    span: "lg:col-span-6",
  },
];

export const CONTACT = {
  email: "info@renewoltenerji.com",
  phone: "0555 010 37 81",
  phoneRaw: "+905550103781",
  instagram: "@renewoltenerjimuhendislik",
  instagramUrl: "https://instagram.com/renewoltenerjimuhendislik",
  address: "Kurtderesi Mah. 6521. Sok. No:6 Samandağ / Hatay",
  website: "renewoltenerji.com",
};
